import React, { useReducer } from 'react'
import EquipmentOrToolsTypesContext from './EquipmentOrToolsTypesContext'
import EquipmentOrToolsTypesReducer from './EquipmentOrToolsTypesReducer'
import { createEquipmentOrToolsTypesService, deleteEquipmentOrToolTypeService, editEquipmentOrToolsTypesService, getEquipmentOrToolsTypesService } from '../../services/Settings'
import { t } from 'i18next'
import { logout } from '../../services/login'

const EquipmentOrToolsTypesState = ({ children }) => {

    const inititalState = {
        types: [],
        typesSearcheable: [],
        type: {
            equipmentDescription: '',
            equipmentEnabled: true,
        },
        isFetching: true,
        isSending: false,
        error: false,
        errorMessage: '',
        successAlert: false,
        successMessage: '',
    }

    const [state, dispatch] = useReducer(EquipmentOrToolsTypesReducer, inititalState);

    const setIsFetching = (value) => dispatch({ type: 'IS_FETCHING', payload: value });

    const setIsSending = (value) => dispatch({ type: 'IS_SENDING', payload: value });

    const setTypes = (types) => dispatch({ type: 'SET_TYPES', payload: types });

    const setType = (type) => dispatch({ type: 'SET_TYPE', payload: type });

    const clean = () => dispatch({ type: 'CLEAN' });

    const setError = (value, errorMessage = '') => dispatch({ type: 'ERROR', payload: { value, errorMessage } });

    const setAlert = (value, alertMessage = '') => dispatch({ type: 'ALERT', payload: { value, alertMessage } });

    const getEquipmentOrToolsTypes = async () => {
        try {
            setIsFetching(true);
            setType(inititalState.type)
            const { data, ok } = await getEquipmentOrToolsTypesService();
            if (ok) {
                dispatch({
                    type: 'GET_TYPES',
                    payload: data.response
                });
            } else {
                const { error_code } = data;
                let errorMessage = '';
                switch (error_code) {
                    case 'AUTH_ERROR':
                        errorMessage = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 2000);
                        break;
                    case 'PARAM_ERROR':
                        errorMessage = t('TOKEN_ERROR');
                        break;
                    default:
                        errorMessage = t('ERROR_TRY_AGAIN');
                        break;
                }
                setError(true, errorMessage);
            }
        } catch (error) {
            setError(true, t('SERVER_ERROR'));
            console.log(error);
        } finally {
            setIsFetching(false);
        }
    }

    const createType = async (type) => {
        try {
            setIsSending(true);
            const { ok, data } = await createEquipmentOrToolsTypesService(type);
            if (ok) {
                setAlert(true, t('TYPE_EQUIPMENT_OR_TOOL_CREATE_SUCCESSFULLY'));
            } else {
                const { error_code } = data;
                let errorMessage = '';
                switch (error_code) {
                    case 'AUTH_ERROR':
                        errorMessage = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 2000);
                        break;
                    case 'PARAM_ERROR':
                        errorMessage = t('TYPE_EQUIPMENT_OR_TOOL_NAME_ALREADY_EXIST')
                        break;
                    default:
                        errorMessage = t('ERROR_TRY_AGAIN');
                        break;
                }
                setError(true, errorMessage);
            }
        } catch (error) {
            setError(true, t('SERVER_ERROR'));
            console.log(error)
        } finally {
            setIsSending(false);
        }
    }

    const getEquipmentOrToolType = async (id) => {
        try {
            const havePrevData = state.typesSearcheable.length > 0;
            if (havePrevData) {
                const { equipmentDescription, equipmentEnabled } = state.typesSearcheable.find(type => type.equipmentTypeId === Number(id))
                setType({
                    equipmentId: id,
                    equipmentDescription,
                    equipmentEnabled: Boolean(equipmentEnabled),
                });
                return
            }
            const { data, ok } = await getEquipmentOrToolsTypesService(id);
            if (ok) {
                if (data.response.length > 0) {
                    const { equipmentDescription, equipmentEnabled } = data.response[0]
                    setType({
                        equipmentId: id,
                        equipmentDescription,
                        equipmentEnabled: Boolean(equipmentEnabled),
                    });
                } else {
                    setError(true, t('ERROR_TRY_AGAIN'));
                }
            } else {
                const { error_code } = data;
                let errorMessage = '';
                switch (error_code) {
                    case 'AUTH_ERROR':
                        errorMessage = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 2000);
                        break;
                    case 'PARAM_ERROR':
                        errorMessage = t('TOKEN_ERROR');
                        break;
                    default:
                        errorMessage = t('ERROR_TRY_AGAIN');
                        break;
                }
                setError(true, errorMessage);
            }
        } catch (error) {
            setError(true, t('SERVER_ERROR'));
            console.log(error);
        }
    }

    const editType = async (type) => {
        try {
            setIsSending(true);
            const { ok, data } = await editEquipmentOrToolsTypesService(type);
            if (ok) {
                setAlert(true, t('TYPE_EQUIPMENT_OR_TOOL_EDIT_SUCCESSFULLY'));
            } else {
                const { error_code } = data;
                let errorMessage = '';
                switch (error_code) {
                    case 'AUTH_ERROR':
                        errorMessage = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 2000);
                        break;
                    case 'PARAM_ERROR':
                        errorMessage = t('TYPE_EQUIPMENT_OR_TOOL_NAME_ALREADY_EXIST')
                        break;
                    case 'NONEXISTENCE_ENTITY':
                        errorMessage = t('ERROR_TRY_AGAIN')
                        break;
                    case 'RESOURCE_IN_WITH_EQUIPMENT':
                        errorMessage = t('TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DISABLED')
                        break;
                    default:
                        errorMessage = t('ERROR_TRY_AGAIN');
                        break;
                }
                setError(true, errorMessage);
            }
        } catch (error) {
            setError(true, t('SERVER_ERROR'));
            console.log(error)
        } finally {
            setIsSending(false);
        }
    }

    const deleteEquipmentOrToolType = async (id) => {
        try {
            setIsSending(true)
            const { data, ok } = await deleteEquipmentOrToolTypeService(id);
            if (ok) {
                setAlert(true, t('TYPE_EQUIPMENT_OR_TOOL_DELETED_SUCCESSFULLY'));
            } else {
                const { error_code } = data;
                let errorMessage = '';
                switch (error_code) {
                    case 'AUTH_ERROR':
                        errorMessage = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 2000);
                        break;
                    case 'PARAM_ERROR':
                        errorMessage = t('TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DELETE');
                        break;
                    default:
                        errorMessage = t('ERROR_TRY_AGAIN');
                        break;
                }
                setError(true, errorMessage);
            }
        } catch (error) {
            setError(true, t('SERVER_ERROR'));
            console.log(error);
        } finally {
            setIsSending(false)
        }
    }

    return (
        <EquipmentOrToolsTypesContext.Provider value={{
            equipmentOrToolsTypesState: state,
            getEquipmentOrToolsTypes,
            createType,
            clean,
            setIsFetching,
            setIsSending,
            setError,
            setAlert,
            setTypes,
            getEquipmentOrToolType,
            editType,
            deleteEquipmentOrToolType,
        }}>
            {children}
        </EquipmentOrToolsTypesContext.Provider>
    )
}

export default EquipmentOrToolsTypesState